import "../styles/style.scss";
import Scene from "./scene";

Scene.init();